import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Notion from "./pages/Notion";
import Automation from "./pages/Automation";
import Stack from "./pages/Stack";
import Nav from "./components/Nav";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/notion" element={<Notion />} />
          <Route path="/automation" element={<Automation />} />
          <Route path="/stack" element={<Stack />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
